function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-nord");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-nord",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.4050163,28.5053585 C14.8003976,27.1648805 16.1996024,27.1648805 16.5949837,28.5053585 L16.5949837,28.5053585 L29.5866097,74.0507567 C29.6299149,74.202574 29.5989757,74.3659258 29.5031523,74.4913917 C29.3355434,74.7108498 29.0217636,74.7528819 28.8023055,74.585273 L28.8023055,74.585273 L15.5,64.4257731 L2.19769453,74.585273 C2.07222858,74.6810964 1.90887679,74.7120356 1.75705955,74.6687304 C1.49150919,74.5929833 1.33764323,74.3163071 1.41339031,74.0507567 L1.41339031,74.0507567 Z M11.9508772,1 L17.6473684,10.9283668 L19.645614,15.1404011 L19.7350877,15.1404011 L19.7350877,1 L24,1 L24,22 L19.0491228,22 L13.3526316,12.0716332 L11.354386,7.85959885 L11.2649123,7.85959885 L11.2649123,22 L7,22 L7,1 L11.9508772,1 Z",
  id: "Combined-Shape-Copy",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4050163,27.5053585 C13.8003976,26.1648805 15.1996024,26.1648805 15.5949837,27.5053585 L15.5949837,27.5053585 L28.5866097,73.0507567 C28.6299149,73.202574 28.5989757,73.3659258 28.5031523,73.4913917 C28.3355434,73.7108498 28.0217636,73.7528819 27.8023055,73.585273 L27.8023055,73.585273 L14.5,63.4257731 L1.19769453,73.585273 C1.07222858,73.6810964 0.90887679,73.7120356 0.757059545,73.6687304 C0.49150919,73.5929833 0.337643234,73.3163071 0.413390313,73.0507567 L0.413390313,73.0507567 Z M10.9508772,0 L16.6473684,9.92836676 L18.645614,14.1404011 L18.7350877,14.1404011 L18.7350877,0 L23,0 L23,21 L18.0491228,21 L12.3526316,11.0716332 L10.354386,6.85959885 L10.2649123,6.85959885 L10.2649123,21 L6,21 L6,0 L10.9508772,0 Z",
  id: "Combined-Shape",
  fill: "#000000"
})));

const SvgIco30Nord = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "29px",
  height: "75px",
  viewBox: "0 0 29 75",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Nord, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-nord.c7716cbd.svg";
export { ForwardRef as ReactComponent };